import { calculatePayroll } from "./payroll";
import { calculateLitigation, calculateSeparation } from "./separation";
import type { CalculatorInput, CalculationResult } from "./types";

export * from "./types";
export * from "./parameters";
export * from "./payroll";
export * from "./separation";
export * from "./tax";

export function calculate(input: CalculatorInput): CalculationResult {
  switch (input.kind) {
    case "payroll":
      return calculatePayroll(input);
    case "finiquito":
    case "liquidation":
      return calculateSeparation(input);
    case "litigation":
      return calculateLitigation(input);
    default: {
      const exhaustive: never = input;
      throw new Error(`Tipo de cálculo no soportado: ${String(exhaustive)}`);
    }
  }
}

